import type { ExperimentsMonitorManager, ScopeTab } from '@/state/experiments/useExperimentsMonitor';
import { SearchInput } from '@/components/SearchInput';
import { useAuth } from 'hooks/useAuth';
import { ScopePills, SEARCH_FIELD_CLASS } from '../ConsolePanel';

export type HeaderProps = {
  manager: ExperimentsMonitorManager;
};

export const Header = ({ manager }: HeaderProps) => {
  const { scopeTab, setScopeTab, search, setSearch } = manager;
  const { user } = useAuth();

  // Stacked below `md`: the scope strip fills a phone on its own, and the search gets
  // the row under it rather than being squeezed beside it.
  return (
    <div className="bg-panel border-line flex flex-col gap-2 rounded-panel border px-3.5 py-2.5 md:flex-row md:flex-wrap md:items-center md:justify-between md:gap-3">
      {/* Shared with Health, so the same three choices read the same on both. */}
      <ScopePills
        value={scopeTab}
        onChange={(scope) => setScopeTab(scope as ScopeTab)}
        isAgency={user?.company?.type === 'Agency'}
      />
      {/* SearchInput collapses to a magnifier below `md` and drops its field in
          absolutely, so it needs a positioned parent of the field's width. */}
      <div className="relative w-full md:w-auto">
        <SearchInput
          className={SEARCH_FIELD_CLASS}
          handleSearch={setSearch}
          value={search}
          placeholder="Search experiments..."
        />
      </div>
    </div>
  );
};
